import { createElement } from "/elements_functions/new_elements.js";

export function createContentRestrictedWindow(message, id=null, classArray=null) {

    let newClassArray;

    if(classArray===null) {
        newClassArray = ['content-restricted-window'];
    } else {
        newClassArray = classArray.concat(['content-restricted-window']);
    }

    const contentRestrictedWindow = createElement('div', id, newClassArray);

    const contentRestrictedImg = createElement('img', null, null);
    contentRestrictedImg.src = '/images/forbidden/forbidden.png';

    const contentRestrictedCaption = createElement('p', null, null);
    contentRestrictedCaption.innerText = message;

    contentRestrictedWindow.append(contentRestrictedImg, contentRestrictedCaption);

    return contentRestrictedWindow;
}